import WikiFeedbackForm from "@/src/components/wiki/wiki-feedback/wiki-feedback-form";
import WikiFeedbackList from "@/src/components/wiki/wiki-feedback/wiki-feedback-list";
import WikiMyFeedbackList from "@/src/components/wiki/wiki-feedback/wiki-my-feedback-list";
import { usePermissions } from "@/src/hooks/use-permissions";
import { useTranslation } from "react-i18next";
import { ScrollView, Text, View } from "react-native";

export default function WikiFeedbackScreen() {
  const { t } = useTranslation();
  const { isSuperAdmin } = usePermissions();

  return (
    <View className="flex-1 bg-obsidian gap-4">
      <ScrollView
        contentContainerClassName="gap-4"
        showsVerticalScrollIndicator={false}
      >
        <View className="bg-chalk px-4 py-4 md:px-6 rounded-2xl md:rounded-[16px] md:border md:border-ash-3">
          <Text className="text-base font-bold text-onyx">
            {t("LABEL_FEEDBACK")}
          </Text>
        </View>

        <View className="bg-chalk rounded-2xl md:rounded-[16px] p-4 md:border md:border-ash-3">
          <WikiFeedbackForm />
          <WikiMyFeedbackList />
        </View>

        {isSuperAdmin && (
          <View className="bg-chalk rounded-2xl md:rounded-[16px] p-4 md:border md:border-ash-3">
            <WikiFeedbackList />
          </View>
        )}
      </ScrollView>
    </View>
  );
}
